// src/models/financeiro/Recebimento.js
const formatarDataLocal = (data) => {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
};

export const obterPrimeiroVencimentoRecebimento = (formaPag, dataBase = new Date()) => {
    const diaVencimento = Number(formaPag?.diaVencimento);
    if (!Number.isInteger(diaVencimento) || diaVencimento < 1 || diaVencimento > 31) {
        return formatarDataLocal(dataBase);
    }

    const ano = dataBase.getFullYear();
    const mesSeguinte = dataBase.getMonth() + 1;
    const ultimoDiaMesSeguinte = new Date(ano, mesSeguinte + 1, 0).getDate();
    return formatarDataLocal(new Date(ano, mesSeguinte, Math.min(diaVencimento, ultimoDiaMesSeguinte)));
};

export const criarParcelasRecebimento = (valorTotal, quantidade, primeiroVencimento) => {
    const totalCentavos = Math.round(Number(valorTotal || 0) * 100);
    const numeroParcelas = Math.max(1, Number(quantidade) || 1);
    const valorBase = Math.floor(totalCentavos / numeroParcelas);
    const restante = totalCentavos - (valorBase * numeroParcelas);
    const [ano, mes, dia] = primeiroVencimento.split('-').map(Number);

    return Array.from({ length: numeroParcelas }, (_, indice) => {
        const ultimoDiaMes = new Date(ano, mes + indice, 0).getDate();
        const vencimento = new Date(ano, mes - 1 + indice, Math.min(dia, ultimoDiaMes));

        return {
            dataVencimento: `${vencimento.getFullYear()}-${String(vencimento.getMonth() + 1).padStart(2, '0')}-${String(vencimento.getDate()).padStart(2, '0')}`,
            valorParcela: (valorBase + (indice < restante ? 1 : 0)) / 100,
        };
    });
};

export const validarRecebimentoManual = (recebimento) => {
    if (!recebimento.clienteId) return 'Informe o cliente.';
    if (!recebimento.formaPagId) return 'Informe a forma de pagamento.';
    if (!recebimento.dataCriacao) return 'Informe a data de emissão.';
    if (!recebimento.parcelas?.length) return 'Informe ao menos uma parcela.';
    if (recebimento.parcelas.some((parcela) => !parcela.dataVencimento)) return 'Informe o vencimento de todas as parcelas.';
    if (recebimento.parcelas.some((parcela) => Number(parcela.valorParcela) <= 0)) return 'O valor das parcelas deve ser maior que zero.';
    return '';
};

export const STATUS_RECEBIMENTO = {
    TODOS: -1,
    PENDENTE: 0,
    PAGO: 1,
    PARCIALMENTE_PAGO: 2,
    CANCELADO: 3,
    NAO_PAGO: 4,
};

export const obterDescricaoStatusRecebimento = (status) => ({
    [STATUS_RECEBIMENTO.PENDENTE]: 'Pendente',
    [STATUS_RECEBIMENTO.PAGO]: 'Pago',
    [STATUS_RECEBIMENTO.PARCIALMENTE_PAGO]: 'Parcialmente pago',
    [STATUS_RECEBIMENTO.CANCELADO]: 'Cancelado',
    [STATUS_RECEBIMENTO.NAO_PAGO]: 'Não Pago',
}[status] || 'Pendente');

export const obterClasseStatusRecebimento = (status) => ({
    [STATUS_RECEBIMENTO.PENDENTE]: 'status-pendente',
    [STATUS_RECEBIMENTO.PAGO]: 'status-pago',
    [STATUS_RECEBIMENTO.PARCIALMENTE_PAGO]: 'status-parcial',
    [STATUS_RECEBIMENTO.CANCELADO]: 'status-cancelado',
}[status] || 'status-pendente');

export const distribuirPagamentoPorVencimento = (parcelas, valorPagamento) => {
    let restante = Math.max(0, Number(valorPagamento) || 0);
    return [...parcelas]
        .sort((a, b) => new Date(a.dataVencimento) - new Date(b.dataVencimento)
            || Number(a.numParcela) - Number(b.numParcela)
            || Number(a.id) - Number(b.id))
        .map((parcela) => {
            const saldo = Math.max(0, Number(parcela.saldo) || 0);
            const valorAplicado = Math.min(restante, saldo);
            restante -= valorAplicado;
            return { ...parcela, valorAplicado };
        })
        .filter((parcela) => parcela.valorAplicado > 0);
};
